export default __webpack_public_path__ + "static/media/mode-39.7a60047e.svg";